import {RouteRecordRaw} from "vue-router";

export const businessRoutes: RouteRecordRaw = {
  path: 'business',
  name: 'Business',
  meta: {requiresAuth: true},
  component: () => import('@/layouts/BusinessLayout.vue'),
  children: [
    {
      path: 'info',
      name: 'BusinessDetails',
      meta: {requiresAuth: true},
      component: () => import('@/features/business/views/Details.vue'),
    },
    {
      path: 'collaborators',
      name: 'Collaborators',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ListCollaborators',
          meta: {requiresAuth: true},
          component: () => import('@/features/business/views/collaborators/Collaborators.vue'),
        },
        {
          path: 'create',
          name: 'CreateCollaborator',
          meta: {requiresAuth: true},
          component: () => import('@/features/business/views/collaborators/Collaborator.vue'),
        },
        {
          path: ':collaboratorID',
          name: 'DetailsCollaborator',
          meta: {requiresAuth: true},
          component: () => import('@/features/business/views/collaborators/Collaborator.vue'),
        },
      ],
    },
    {
      path: 'inventory',
      name: 'BusinessInventory',
      meta: {requiresAuth: true},
      component: () => import('@/features/inventory/views/Inventory.vue'),
    },
    {
      path: 'balance',
      name: 'BusinessBalance',
      meta: {requiresAuth: true},
      component: () => import('@/features/billing/views/Balance.vue'),
    },
    {
      path: 'formats',
      name: 'FormatDashboard',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'Formats',
          meta: {requiresAuth: true},
          component: () => import('@/features/business/views/formats/Formats.vue'),
        },
        {
          path: 'create',
          name: 'CreateFormat',
          meta: {requiresAuth: true},
          component: () => import('@/features/business/views/formats/Format.vue'),
        },
      ],
    },
    {
      path: 'database',
      name: 'Database',
      meta: {requiresAuth: true},
      component: () => import('@/features/business/views/database/Database.vue'),
      children: [],
    },
  ],
};
